// extracted by mini-css-extract-plugin
export var csatScore = "_o4-5";
export var header = "_o4-1";
export var panelWrapper = "_o4-2";
export var postPreview = "_o4-3";
export var rightContent = "_o4-0";
export var wrappingText = "_o4-4";